import React, { createContext, useReducer } from 'react';
import AnimalQuestions from '../components/InsuranceOffer/AnimalQuestions';
import BoatQuestions from '../components/InsuranceOffer/BoatQuestions';
import ForestQuestions from '../components/InsuranceOffer/ForestQuestions';
import HomeQuestions from '../components/InsuranceOffer/HomeQuestions';
import PersonQuestions from '../components/InsuranceOffer/PersonQuestions';
import TravelQuestions from '../components/InsuranceOffer/TravelQuestions';
import ValuablesQuestions from '../components/InsuranceOffer/ValuablesQuestions';
import VehiclesQuestions from '../components/InsuranceOffer/VehiclesQuestions';
import {
  IconCategoryAnimals,
  IconCategoryBoats,
  IconCategoryForest,
  IconCategoryHome,
  IconCategoryPerson,
  IconCategoryTravel,
  IconCategoryValuables,
  IconCategoryVehicles,
} from '../components/common/Icon';
import insuranceSelectionReducer from '../reducers/insuranceSelectionReducer';

import ValidateAnimalQuestions from '../validators/ValidateAnimalQuestions';
import ValidateBoatQuestions from '../validators/ValidateBoatQuestions';
import ValidateForestQuestions from '../validators/ValidateForestQuestions';
import ValidateHomeQuestions from '../validators/ValidateHomeQuestions';
import ValidatePersonQuestions from '../validators/ValidatePersonQuestions';
import ValidateTravelQuestions from '../validators/ValidateTravelQuestions';
import ValidateValuablesQuestions from '../validators/ValidateValuablesQuestions';
import ValidateVehiclesQuestions from '../validators/ValidateVehiclesQuestions';

const initialData = {
  tiles: [
    {
      insuranceId: 'vehicle',
      icon: IconCategoryVehicles,
      component: VehiclesQuestions,
      validator: ValidateVehiclesQuestions,
      count: 0,
    },
    {
      insuranceId: 'home',
      icon: IconCategoryHome,
      component: HomeQuestions,
      validator: ValidateHomeQuestions,
      count: 0,
    },
    {
      insuranceId: 'person',
      icon: IconCategoryPerson,
      component: PersonQuestions,
      validator: ValidatePersonQuestions,
      count: 0,
    },
    {
      insuranceId: 'travel',
      icon: IconCategoryTravel,
      component: TravelQuestions,
      validator: ValidateTravelQuestions,
      count: 0,
    },
    {
      insuranceId: 'animal',
      icon: IconCategoryAnimals,
      component: AnimalQuestions,
      validator: ValidateAnimalQuestions,
      count: 0,
    },
    {
      insuranceId: 'boat',
      icon: IconCategoryBoats,
      component: BoatQuestions,
      validator: ValidateBoatQuestions,
      count: 0,
    },
    {
      insuranceId: 'forest',
      icon: IconCategoryForest,
      component: ForestQuestions,
      validator: ValidateForestQuestions,
      count: 0,
    },
    {
      insuranceId: 'valuable',
      icon: IconCategoryValuables,
      component: ValuablesQuestions,
      validator: ValidateValuablesQuestions,
      count: 0,
    },
  ],
  insuranceSelectionIndex: 0,
  selectedInsurances: [],
  contactInfo: {},
  contactInfoErrors: {},
  showInsuranceErrorMessage: false,
  showInsurances: false,
  showContactInfo: false,
  showExceptionMessage: false,
};

const InsuranceOfferContext = createContext();
const InsuranceOfferProvider = ({ children }) => {
  const [state, dispatch] = useReducer(insuranceSelectionReducer, initialData);

  return (
    <InsuranceOfferContext.Provider value={[state, dispatch]}>
      {children}
    </InsuranceOfferContext.Provider>
  );
};

InsuranceOfferProvider.displayName = 'InsuranceOfferProvider';
export { InsuranceOfferContext, InsuranceOfferProvider };
